import { render } from "./signatures.vue?vue&type=template&id=2b3935c6&scoped=true"
import script from "./signatures.vue?vue&type=script&lang=js"
export * from "./signatures.vue?vue&type=script&lang=js"

import "./signatures.vue?vue&type=style&index=0&id=2b3935c6&scoped=true&lang=css"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3935c6"]])

export default __exports__